/* import __COLOCATED_TEMPLATE__ from './state.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';

interface Signature {
  Args: {
    conversationEntry: ConversationTableEntry;
    onClick: () => void;
  };
}

const State = templateOnlyComponent<Signature>();
export default State;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::State': typeof State;
    'inbox2/conversations-table/table-cells/state': typeof State;
  }
}
